"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("./index");
function getBroadcastTimeRange(serverTimeDelta, broadcast) {
  var _broadcast$startOn = broadcast.startOn,
    startOn = _broadcast$startOn === void 0 ? 0 : _broadcast$startOn,
    _broadcast$endOn = broadcast.endOn,
    endOn = _broadcast$endOn === void 0 ? 0 : _broadcast$endOn;
  var serverStartTime = (0, _index.getServerTime)(startOn, serverTimeDelta);
  var serverEndTime = (0, _index.getServerTime)(endOn, serverTimeDelta);
  var serverTimeToStart = (0, _index.getSecondsTo)(serverStartTime);
  var serverTimeToEnd = (0, _index.getSecondsTo)(serverEndTime);
  return {
    serverTimeToStart: serverTimeToStart,
    serverTimeToEnd: serverTimeToEnd
  };
}
var _default = exports["default"] = getBroadcastTimeRange;